module.exports = __webpack_public_path__ + "img/pakiet_2.7b98528e.svg";